// window.Vue = require('vue');

import Vue from 'vue';

import '../../cockpit/js/plugins/sweetalert2.js';
import '../../cockpit/js/plugins/clipboard.js';
import '../../cockpit/js/plugins/keyboard-shortcuts.js';
import '@babel/polyfill';

import store from '../../cockpit/js/store/store';

import router from './routes.js';

import 'normalize.css';

require('../../bootstrap.js');
require('../../vendor/quasar-framework/0.17.19/dist/umd/quasar.ie.polyfills.umd.min.js');
window.Quasar = require('../../vendor/quasar-framework/0.17.19/dist/umd/quasar.mat.umd.js');

Vue.use(require('vue-moment'));

new Vue({
	el: '#app',
	// eslint-disable-next-line vue/component-definition-name-casing
	name: 'app',
	router,
	store
});

window.Vue = Vue;
